function loadReoScript(config) {
    const scriptUrlPattern = config.scriptUrlPattern || "https://static.reo.dev/<clientID>/reo<version>.js";
    const clientID = config.clientID;
    const version = config.version || "";

    if (!clientID || typeof clientID !== "string") {
        throw new Error("clientID required");
    }

    const scriptUrls = (Array.isArray(scriptUrlPattern) ? scriptUrlPattern : [scriptUrlPattern]).map((url) => {
        // Replace placeholders in the URL with actual values
        return url.replace(/<clientID>/g, clientID)
                  .replace(/<version>/g, version);
    });

    // Load the script and handle errors
    return loadScript(scriptUrls);

    function loadScript(scriptUrls) {
        return new Promise((resolve, reject) => {
            const loadScript = (url) => {
                const scriptElement = document.createElement("script");
                scriptElement.onload = () => {
                    if(typeof window !== 'undefined' && window.Reo) {
                        resolve(Reo);
                    }  else {
                        reject(new Error('Failed to load the script or access methods.'));
                    }
                }
                scriptElement.onerror = (error) => reject(new Error("Failed to load the JS script of the agent"));
                scriptElement.async = true;
                scriptElement.src = url;

                // Append the script element to the document
                document.head.appendChild(scriptElement);
            };

            // Try loading scripts in sequence
            const loadScriptWithRetry = (index) => {
                if (index < scriptUrls.length) {
                    loadScript(scriptUrls[index])
                        // .catch(() => {
                        //     // Retry loading the next script with an exponential backoff
                        //     const delay = Math.random() * Math.min(3000, 100 * 2 ** index);
                        //     setTimeout(() => loadScriptWithRetry(index + 1), delay);
                        // });
                } else {
                    // All scripts loaded successfully
                    resolve();
                }
            };

            // Start loading scripts
            loadScriptWithRetry(0);
        });
    }
}

export { loadReoScript };